(() => {
  const getHeaderHeight = () => {
    const header = document.querySelector("#header, .header, .js-header");
    return header ? header.offsetHeight : 0;
  };

  const getScrollPaddingTop = () => {
    const value = getComputedStyle(document.documentElement).scrollPaddingTop;
    return Number.parseFloat(value) || 0;
  };

  const getScrollOffset = () => getScrollPaddingTop() || getHeaderHeight();

  const getTarget = (hash) => {
    if (!hash || hash === "#") {
      return null;
    }

    return document.getElementById(decodeURIComponent(hash.slice(1)));
  };

  const isSamePageLink = (link) => {
    const url = new URL(link.href, window.location.href);

    return (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search
    );
  };

  const scrollToTarget = (target, behavior = "smooth") => {
    const position =
      target.getBoundingClientRect().top + window.scrollY - getScrollOffset();

    window.scrollTo({
      top: position,
      behavior,
    });
  };

  // ページ内のスムーススクロール
  for (const link of document.querySelectorAll('a[href*="#"]')) {
    link.addEventListener("click", (e) => {
      if (!isSamePageLink(e.currentTarget)) {
        return;
      }

      const hash = e.currentTarget.hash;
      const target = getTarget(hash);

      // ページトップへ("#"と"#top"）
      if (!hash || hash === "#" || hash === "#top") {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        history.pushState(null, "", window.location.pathname + window.location.search);
        return;
      }

      // アンカーへ
      if (target) {
        e.preventDefault();
        scrollToTarget(target);

        // URLにハッシュを含める
        history.pushState(null, "", hash);
      }
    });
  }

  // 別ページ遷移後にスムーススクロール
  const urlHash = window.location.hash;
  const target = getTarget(urlHash);

  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, "", window.location.pathname + window.location.search);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      scrollToTarget(target);

      // ハッシュを再設定
      history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search + urlHash,
      );
    });
  }
})();
